import { render, staticRenderFns } from "./ClarenceNotifications.vue?vue&type=template&id=1c079f97&scoped=true"
import script from "./ClarenceNotifications.vue?vue&type=script&lang=js"
export * from "./ClarenceNotifications.vue?vue&type=script&lang=js"
import style0 from "./ClarenceNotifications.vue?vue&type=style&index=0&id=1c079f97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c079f97",
  null
  
)

export default component.exports